<template>
  <div>
    <div class="btn-add text-xs-center my-2" v-if="!value" @click="show = true">
      {{ $t('Select page post') }}
    </div>
    <div class="z-border-red" v-else>
      <v-layout>
        <v-flex class="pl-4 py-2">
          <div class="primary--text">{{ value.name | truncate(200) }}</div>
          <div class="caption grey--text">
            {{ value.id }}
          </div>
        </v-flex>
        <v-flex shrink>
          <v-btn depressed color="primary" @click="show = true">{{ $t('Select') }}</v-btn>
          <v-btn depressed color="primary" @click="$emit('resetSelectPost')">{{
            $t('Select all')
          }}</v-btn>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog v-model="show" max-width="800">
      <v-card>
        <div class="text-xs-right">
          <v-btn small @click="show = false" fab flat><v-icon>close</v-icon></v-btn>
        </div>
        <v-card-text>
          <div class="text-xs-center py-4" v-if="loading">
            <div class="spinner text-xs-center">
              <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
            </div>
          </div>
          <template v-else>
            <template v-if="posts.length > 0">
              <template v-for="(post, index) in posts">
                <div class="z-border-red mb-2 pa-2" :key="index">
                  <v-layout>
                    <v-flex class=" pa-2">
                      <div class="primary--text">{{ post.name | truncate(200) }}</div>
                      <div class="caption grey--text">
                        {{ post.id }}
                      </div>
                    </v-flex>
                    <v-flex class="text-xs-right pa-2">
                      <v-btn
                        small
                        depressed
                        class="ma-0 extra-small"
                        color="primary"
                        @click="onSelectPost(post)"
                      >
                        {{ $t('Select') }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </div>
              </template>
              <div class="text-xs-center">
                <v-btn
                  color="primary"
                  outline
                  v-if="nextPost"
                  @click="getPublishedPost"
                  :loading="loading"
                  >{{ $t('Next') }}</v-btn
                >
              </div>
            </template>

            <template v-else>
              <div class="text-xs-center">{{ $t('No post') }}</div>
            </template>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
export default {
  props: ['value'],
  data() {
    return {
      show: false,
      nextPost: null,
      loading: true,
      hasMore: false,
      posts: []
    }
  },
  async mounted() {
    await this.getPublishedPost()
  },
  methods: {
    onSelectPost(post) {
      this.show = false
      this.$emit('input', post)
      this.$emit('changePost')
    },
    getPublishedPost: function() {
      return new Promise((resolve, reject) => {
        var vm = this
        vm.loading = true

        api.getPublishedPost(vm.nextPost).then(
          function(response) {
            if (response.paging && response.paging.next) {
              vm.nextPost = response.paging.next
            } else {
              vm.hasMore = false
            }
            if (response.data) {
              vm.posts = response.data.map(function(post, index) {
                if (post.message || post.story) {
                  return {
                    id: post.id,
                    name: post.message ? post.message : post.story,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  }
                } else {
                  return {
                    id: post.id,
                    name: post.id,
                    selected: vm.posts ? vm.posts.includes(post.id) : false
                  }
                }
              })
              vm.loading = false
              resolve()
            }
          },
          function(e) {
            vm.loading = false
            reject(e)
          }
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/SelectPagePost.vue